import login from "./login"

export default {
  login,
  api_messages: {
    project_access_denied: "Přístup zamítnut",
    wrong_password: "Nesprávné heslo",
    email_not_verified: "Zatím jste nepotvrdil/a Vaši emailovou adresu, pokud jste neobdržel/a potvrzující email, klikněte zde:"
  }
}